import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [CommonModule, RouterModule],
  exports: [AppComponent],
  providers: [],
})
export class MangoEventAnalyticsModule {}
